export enum EventActions {
    EDIT,
    NEW,
    COPY,
    DELETE,
    RELOAD,
}
